/**
 * Created by wangshhj on 2018/1/11.
 * 说明
 * 查询区组件的核心数据存在 this.state.searchInfo内。
 * 查询区内部存在3个状态,simple：简单查询，nomarl：普通，super:高级 ,存在 this.state.searchInfo.status。
 * 查询区用户输入的数据（主要是value和 操作符数据）存在 this.state.searchInfo.snapshotMap里面，它有四个属性对应3个状态（simple,nomarl,super）
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { setMultiLang, addEventListener, getICFlag, setICFlag } from './methods';
import {
    initDefaultSnapshot,
    initSearchArea,
    initSimpleSnap,
    _clone,
    tree2Array,
    setOperationOptionsMultiLang,
    MultiLangOpt,
    uniqueArray,
    compareObjectArraysSelective,
    observe,
} from './_methods';
import {
    getMultiLang,
    getSysFieldid,
    ViewModel,
    isFunction,
    isEmpty,
    PubSub,
    getSafeRandom,
    getAppReqParam,
    ajax,
    getGlobalStorage,
} from '@platform/api';
import SearchAdvModal from './SearchAdvModal';
import SearchSimCom from './searchSimCom';
import SearchAdvCom from './SearchAdvCom';
import { getQuerySchemeList } from './service';
import {
    setMultiLang as getFunctionList,
    timeFunctionHandler,
} from 'platform/base/DatePickerTimeZoneConversion/dateFunction';

import shareTableMeta from './shareTableMeta';

function uuidv4() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (getSafeRandom() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
require('./createSearch.less');
// 查询区渲染完成发布订阅标识
const COMPLETE = 'areaChangeComplete';
/**
 * 查询区组件，包括简单查询和高级查询两个组件组成，根据不同的参数，共有几种展示形态
 * 1.完全体：简单查询+高级查询
 * 2.只有简单查询：只渲染预置方案，没有高级按钮和方案列表
 * 3.只有高级查询：只渲染一个按钮，该按钮点击用来打开和关闭高级查询
 * 4.只有高级查询的弹框：直接通过api控制高级查询的打开和关闭
 * 5.将高级查询区的内容直接显示在普通查询区
 *
 * 该组件的功能主要时控制这几种形态的渲染，根据模板初始化出查询区内部需要的数据结构
 */
export default class SearchComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchInfo:{
                leftTab: '1',
                isRenderAdv: false,
                //currentPlan: {}, //当前方案 普通查询区用的
                // currentClickPlan: {},// 普通查询当前选中的方案，用来打开高级查询初始化默认显示的方案
                // showSearchItems: '',//控制展开收起  false:展开  true:收起
                // showAdvModal: true,//控制高级弹窗打开关闭
                searchPlanName: {},
                // defaultPlan: {},//默认方案，模板拼成的方案
                // fixedConditionGroup: [],//固定条件数组
                // isCompleted: false,//查询区的state是否初始化完成
                // isDefaultPlan: true,//是否默认查询方案
                searchPlanCache: [], //所有的查询方案包含模板拼成的
                originalQueryScheme:[], //从后端查接口返回的查询方案,用于适应一个查询区组件，切换多个查询区id的场景。
                snapshotCache: { simple: {}, normal: {}, super: {} }, //快照缓存：用在api赋值的时候
                snapshotMap: { simple: [], normal: [], super: [] }, //快照对象，查询区显示的查询条件
                itemsMap: {}, //将模板转换为对象，方便取值
                status: 'simple', //目前查询区的状态
                uniqueKey: uuidv4(),
                showIgnoreCaseSwitch:false, //显示忽略大小写开关
                multiLangOpt:new MultiLangOpt(props.context.languageMetas), //操作查询方案多语的方法对象
                loadQuerySchemeFlag:false

            },
            json: {},
            LangData: {},
            userControlAll: false,
        };
        // 业务组自定义查询区域 ，点查询方案时，不用展示方案中的未填写项
        if (isFunction(props.replaceRightBody)) {
            this.state.userControlAll = true;
        }
        this._this = props.getGloablThis();
        this.props.currentSearch = true;
        props.get_this(this); //把当前this 注册到全局this去
        this.preHandlerFlag = true;
        this.searchAreaHeight = 0;
        this.multiLangFlag = false;
        this.firstOpenAdv = false;
        // this.props.useFunc.table('searchShareTable');
        this.props.useFunc.cardTable('searchShareTable');
        this.activeElement = null;
    }

    UNSAFE_componentWillMount() {
        const props = this.props;

        let callback = (json, bool, LangData) => {
            setMultiLang(json);
            this.multiLangFlag = true;
            setOperationOptionsMultiLang(json);
            this.setState({ json, LangData });
        };

        if (props.useCache) {
            let state = ViewModel.getData(`search_${props.meta.oid}`, props._runContext);
            if (state) {
                props.meta.items.forEach(
                    item => (state.searchInfo.itemsMap[item.attrcode] = item),
                );
                state.searchInfo.isRenderAdv = false;
                this.multiLangFlag = true;
                this.setState({ ...state });
                if(isEmpty(state.json)){
                    getMultiLang({ moduleId: 'page_search', callback });
                }
                return;
            }
        }
        this.changeMetaHandle(props);
        let info = this.state.searchInfo;
        info.searchKey = true;
        initSearchArea(props, info);
        // 初始化调用getMultiLang方法获取多语
       
        getMultiLang({ moduleId: 'page_search', callback }); // moduleId为所需加载json文件夹名称前缀
    }

    componentDidMount() {
        let that = this;
        let renderCompleteEvent = this.props.renderCompleteEvent;
        // 发布通知表格更新高度
        PubSub.publish(COMPLETE, true);
        setTimeout(() => {
            if (!isEmpty(that.props.meta)) {
                that._this.infoExchangeController.publish('heightChange', {
                    area: 'searchArea',
                    target: this.searchDom,
                });
                if (this.multiLangFlag) {
                    this.multiLangFlag = false;
                    renderCompleteEvent && renderCompleteEvent('');
                }
                // 查询区未创建增加监听事件，放在this.myState.search上，在创建完成需要取出来绑定给相应事件
                let listenerId = `listener_${that.props.moduleId}`;
                let listenerList = that._this.myState.search[listenerId] || [];
                for (let index = 0; index < listenerList.length; index++) {
                    const element = listenerList[index];
                    let [[eventName, callback]] = Object.entries(element);
                    if (eventName && Array.isArray(callback)) {
                        callback.forEach(fun =>
                            addEventListener.call(
                                that._this,
                                that.props.moduleId,
                                eventName,
                                fun.callback,
                                fun.tableQuery,
                            ),
                        );
                    }
                }
                let { renderCompleteEvent: renderCompleteEventCallback } =
                    this.state.searchInfo;
                if (
                    renderCompleteEventCallback &&
                    Array.isArray(renderCompleteEventCallback)
                ) {
                    renderCompleteEventCallback.forEach(fun => {
                        typeof fun == 'function' && fun();
                    });
                }
            }
        });
        this.getQueryScheme({ isAdvSearch: false });
        
    }

    render() {
        return NCCreateSearch.call(this, this.props);
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (this.props.moduleId !== props.moduleId) {
            props.get_this(this); //把当前this 注册到全局this去
        }
        let info = this.state.searchInfo;
        this.changeMetaHandle(props);
        info.searchKey = this.props.searchKey === props.searchKey;
        if (!info.showAdvModal && !props.onlyShowAdvArea) {
            initSearchArea(props, info);
        }
        if (this.props.moduleId !== props.moduleId) {
            info.currentPlan = info.defaultPlan;
        }
        if(props.onlyShowAdvArea){
            if(!info.currentPlan.renderobj4web_snap){
                initSimpleSnap(props.context, info, info.currentPlan);
            }
        }
    }

    componentDidUpdate() {
        let renderCompleteEvent = this.props.renderCompleteEvent;
        if (this.searchDom) {
            if (this.searchAreaHeight !== this.searchDom.offsetHeight) {
                // 发布通知表格更新高度
                PubSub.publish(COMPLETE, true);
                this.searchAreaHeight = this.searchDom.offsetHeight;
            }
        }
        if (this.multiLangFlag) {
            this.multiLangFlag = false;
            renderCompleteEvent && renderCompleteEvent('');
        }
    }

    componentWillUnmount() {
        if (this.props.useCache) {
            ViewModel.setData(`search_${this.props.meta.oid}`, this.state, this.props._runContext);
        }
        this.props.clear_this();
        PubSub.publish(COMPLETE, true);
        // 移除 pubsub 事件监听
        PubSub.unsubscribe('searchRequired_' + this.props.moduleId);
        PubSub.unsubscribe('clearWarning_' + this.props.moduleId);
    }

    changeMetaHandle = props => {
        
        let info = this.state.searchInfo;
        //处理IC逻辑
        info.showIgnoreCaseSwitch = !!props.meta?._layoutData?.ignoreCase;

        if(info.showIgnoreCaseSwitch){
            if(getICFlag(this.props.moduleId) === undefined){
                setICFlag(this.props.moduleId, info.showIgnoreCaseSwitch);
            }
        }else{
            setICFlag(this.props.moduleId, undefined);
        }
        //初始化meta数据
        let initMetaData = initDefaultSnapshot(
            props.meta.items,
            props.context,
            props.isTemplateOrder,
            props.isWidgetMode,
        );
        let defaultRenderobj4web = initMetaData.visibleItem;
        info.fixedConditionGroup = initMetaData.fiexedList;
        // let prev = Object.keys(info.itemsMap);
        // info.itemsMap = {};
        props.meta.items.forEach(
            item => (info.itemsMap[item.attrcode] = item),
        );
        const prevDefaultRenderobj4web = info?.defaultPlan?.renderobj4web || [];
        const compareFields = ['attrcode', 'isfixedcondition', 'itemtype', 'required', 'visible'];
        //改了当前模板
        let isEditTemplate = !compareObjectArraysSelective(prevDefaultRenderobj4web, defaultRenderobj4web, compareFields);
        //改了 当前值
        // let isEditValue = !compareObjectArraysSelective(prev, next);
        let isEdit = isEditTemplate;
        if(!info.searchKey){
            isEdit = true;
        }
        info.isEdit = isEdit;
        // let next = Object.keys(info.itemsMap);
        // let prevLenth = prev.length;
        // let nextLenth = next.length;
        
        // if (!info.searchKey) {
        //     isEdit = true;
        // } else if (prevLenth !== nextLenth) {
        //     isEdit = true;
        // } else {
        //     for (let index = 0; index < prev.length; index++) {
        //         if (prev[index] !== next[index]) {
        //             isEdit = true;
        //             break;
        //         }
        //     }
        // }

        //如果此时模板上新增或删除了某一个字段设置默认，还得进行一次过滤
        let finalSortField = [];
        let schemaSortField = [];
        let metaSortfield = props.meta.sortField || [];
        let schemaSortObj = {};
        let metaSortObj = {};
        let newAddSortField = [];

        if (
            Array.isArray(props.meta.queryschemes) &&
            Array.isArray(props.meta.queryschemesdto)
        ) {
            props.meta.queryschemesdto.forEach(i => {
                let queryScheme = i.querySchemeVO;
                if (
                    i.querySchemeUserVO &&
                    i.querySchemeUserVO.isdefaultdisplay
                ) {
                    if(queryScheme.sortfield){
                        schemaSortField = queryScheme.sortfield;
                    }
                }
            });
        }
        
        if(schemaSortField.length !== 0 ){
            schemaSortField.forEach(item => {
                schemaSortObj[item.refcode] = item;
            });
            metaSortfield.forEach(item => {
                metaSortObj[item.refcode] = item;
            });
            schemaSortField.forEach(item => {
                if(Object.keys(metaSortObj).includes(item.refcode)){
                    finalSortField.push(item);
                }
            });

            metaSortfield.forEach(item => {
                if(!Object.keys(schemaSortObj).includes(item.refcode)){
                    newAddSortField.push(item);
                }
            });
            props.meta.sortField = [...finalSortField, ...newAddSortField];
        }
        // 下面是处理默认方案
        info.defaultPlan = {
            pk_ncc_queryscheme: '001',
            isMyPlan: false,
            isprepared: true,
            name: this.state.json['page-search-0018'],
            labelName:this.state.json['page-search-0018'],
            renderobj4web: JSON.parse(JSON.stringify(defaultRenderobj4web)),
            sortField: metaSortfield || [],
            areacode:props.meta.code,
        };
        if (Array.isArray(props.meta.queryschemes)) {
            let quickqs = props.meta.queryschemes.find(
                i => i.isquickqs && i.isprepared,
            );
            if (quickqs && Array.isArray(quickqs.renderobj4web)) {
                let quicksconditions = tree2Array(quickqs.renderobj4web);
                if (Array.isArray(quicksconditions)) {
                    quicksconditions.forEach(element => {
                        let code = element.attrcode;
                        let item = info.itemsMap[code];
                        if (item) {
                            element.remove = !item.required;
                        }
                    });
                }
            }
        }

        //queryschemes中为模板上返回的查询方案，这里存储了多语的name、name2、name3
        //不管它这里返回什么，name要改写为当前系统语种对应的值
        if(Array.isArray(props.meta.queryschemes)){
            props.meta.queryschemes.forEach(item => {
                const name123 = info.multiLangOpt.createName123(item);
                item.labelName = info.multiLangOpt.getCurrentLanguageValueFromName123(name123) || item.name;
                item.isMyPlan = !item.isprepared && !item.isshared;
            });
        }

        if(info.searchPlanCache.length === 0){
            info.searchPlanCache = [
                info.defaultPlan,
                ...(props.meta.queryschemes || []),
            ];
        }else{
            info.searchPlanCache = uniqueArray([info.defaultPlan, ...(props.meta.queryschemes || []), ...(info.searchPlanCache.filter(item => item.areacode === props.meta.code))], 'pk_ncc_queryscheme');
            // info.searchPlanCache = [ 
            //     info.defaultPlan,
            //     ...(props.meta.queryschemes || []),
            //     ...info.searchPlanCache.filter(item => item.areacode === props.meta.code),
            // ];
        }
    }
    getQueryScheme = ({ isAdvSearch }) => {
        const { meta, customAppCode, customPageCode, loadQuerySchemeWhenAdvSearch } = this.props;
        const { searchInfo } = this.state;
        let queryScheme = true;
        if(loadQuerySchemeWhenAdvSearch && !isAdvSearch){
           queryScheme = false;
        }
        if(!searchInfo.loadQuerySchemeFlag && queryScheme){
            getQuerySchemeList({ pageCode:customPageCode, appCode:customAppCode, metaId: meta.metaid }).then(data => {
                if(Array.isArray(data)){
                    data.forEach(item => {
                        const name123 = searchInfo.multiLangOpt.createName123(item);
                        item.labelName = searchInfo.multiLangOpt.getCurrentLanguageValueFromName123(name123) || item.name;
                        item.isMyPlan = !item.isprepared && !item.isshared;
                    });
                    searchInfo.originalQueryScheme = data;
                    searchInfo.searchPlanCache = uniqueArray([...searchInfo.searchPlanCache, ...(data.filter(item => item.areacode === meta.code))], 'pk_ncc_queryscheme', true);
                   
                }
                searchInfo.loadQuerySchemeFlag = true;
                
                this.setStateEve();
                
            });
        }

    };

    /* 修改查询方案 */
    searchPlanCacheChange = newSearch => {
        //把新的方案同步到模板上
        // this._this.state.meta[this.props.moduleId].queryschemes = newSearch.filter(item => item.pk_ncc_queryscheme != '001');
        this.props.meta.queryschemes = newSearch.filter(
            item => item.pk_ncc_queryscheme != '001',
        );
        this.setStateEve();
    };

    //更新查询区数据
    setStateEve = callBack => {
        this.setState({ ...this.state.searchInfo }, function () {
            if (typeof callBack === 'function') {
                callBack();
            }
        });
    };
    getChildrenRefToB = ref => {
        //这里时为了业务能够使用api保存/另存新方案
        if (ref) {
            this.savePlanFun = ref.saveSearchPlanClick;
            this.queryFun = ref.searchBtnClickEve;
            this.cancelClick = ref.cancelClick;
            this.addPlanFun = ref.addSearchPlanClick;
            this.sharePlanFun = ref.shareSearchPlanClick;
        }
    };
}

function NCCreateSearch({
    moduleId,
    meta,
    clickSearchBtn, // 查询按钮点击事件回调，只返回公共查询条件，不包含自定义查询条件；如果有自定义查询条件，需要业务组在clickPlanEve方法中接收查询方案信息，并保存到业务组的state中，然后在 clickSearchBtn方法中自行合并公共条件和自定义条件。
    searchBtnName = '',
    onAfterEvent, // 编辑后事件
    onBeforeEvent,
    showSearchBtn = true, // 是否显示查询按钮 ,默认显示
    showAdvBtn = true, // 是否显示高级查询按钮和查询方案按钮 ,默认显示
    hideMoreBtn = false, // 是否显示高级查询按钮和查询方案按钮 ,默认显示
    showClearBtn = true, // 是否显示清空按钮
    showClearCurrentBtn = false,
    showAdvSearchPlanBtn = true, // 高级面板中是否显示保存和另存方案按钮
    showAddSearchPlan = true,
    replaceAdvBtnEve, // 业务组替换高级面板 (fun)
    replaceAdvBody, // 业务组替换高级面板中的body (fun)
    addAdvTabs, // 添加高级查询区自定义页签 (fun)
    addAdvBody, // 添加高级查询区右侧自定义查询条件Dom (fun)
    addAdvBodyBottom,
    replaceRightBody, // 替换高级面板右侧body区域 (fun)
    hideSearchCondition = false, // 是否显示高级查询左侧的候选条件
    hideSearchPlan = false, // 是否显示高级查询左侧的查询方案
    saveSearchPlan, // 保存查询方案确定按钮事件 ，用于业务组返回自定义的查询条件
    clickPlanEve, // 点击高级面板中的查询方案事件 ,用于业务组为自定义查询区赋值
    clickAdvBtnEve, //单击高级之后的回调方法
    hideBtnArea = false, // 隐藏查询按钮区域，默认false
    advSearchClearEve, // 高级查询面板中的清空按钮 点击事件回调，用于业务组清除自定义查询条件值
    advSearchClearCurrentEve,
    onlyShowSuperBtn = false, // 只显示高级按钮
    showFoldBtn = true,
    replaceSuperBtn = '', // 替换高级按钮
    onOperateTypeChange, // 操作符改变时的回调
    onlyShowAdvArea = false, //在查询区只显示 高级查询部分
    onlyShowModal = false, //在查询区只显示模态框
    renderCompleteEvent, //渲染完成回调函数
    statusChangeEvent, //状态切换
    context = {},
    renderItem = {},
    setInitValueEvent,
    isSynInitAdvSearch,
    onlyShowPlan = false, // 只显示方案列表和高级查询
    searchModalTitle = '', // 高级查询区 modal title
    searchConditionName = '', //高级查询 "查询条件" 名称自定义
    currentSearch = true,
    fieldid,
    opneBtnClick, //点击展开收起的回调
    removeQuerConditionEve, //删除查询条件的回调
    onDropConditionEve,
    isTemplateOrder,
    hideSearchType = false, //隐藏高级擦查询的普通和高级radio
    onlyShowSuperCondition = false,
    hiddenFunList,
    modalCloseEve,
    clickShowLableEve,
    showSearchLable,
    showLable,
    isWidgetMode,
    runMode,
    underlineBorder,
    shareTableFunc,
    customAppCode, //不在当前页面查询区的应用编码
    customPageCode, //不在当前页面查询区的页面编码
    hiddenShareBtn,
    maxColumn,
    customAdvBtns,
} = {}) {
    let searchInfo = this.state.searchInfo;
    let multiLang = this.state.json;
    let LangData = this.state.LangData;
    const setStateEve = this.setStateEve;
    let that = this;
    //这里时为了业务能够使用api打开活关闭高级查询
    // searchAdvBtnClick = searchAdvBtnClick.bind(this);
    this.searchAdvBtnClick = searchAdvBtnClick;
    // this.queryExcludeTemplateSchema = queryExcludeTemplateSchema;
    if (!isEmpty(multiLang)) {
        // setMultiLang(multiLang);
        // setOperationOptionsMultiLang(multiLang);
        if (
            this.state.searchInfo.hasOwnProperty('snapshotMap') &&
            this.preHandlerFlag
        ) {
            this.preHandlerFlag = false;
            metaPreHandler(meta, multiLang);
        }
    }

    if (!isEmpty(multiLang) && !isEmpty(searchInfo.searchPlanCache)) {
        searchInfo.searchPlanCache.forEach(item => {
            if (item.pk_ncc_queryscheme == '001') {
                item.name = multiLang['page-search-0018'];
                item.labelName = multiLang['page-search-0018'];
            }
        });
        if (searchInfo.defaultPlan) {
            searchInfo.defaultPlan.name = multiLang['page-search-0018'];
            searchInfo.defaultPlan.labelName = multiLang['page-search-0018'];
        }
        if (
            searchInfo.currentPlan &&
            searchInfo.currentPlan.pk_ncc_queryscheme == '001'
        ) {
            searchInfo.currentPlan.name = multiLang['page-search-0018'];
            searchInfo.currentPlan.labelName = multiLang['page-search-0018'];
        }
    }
    searchBtnName = searchBtnName || <i className="iconfont icon-chaxun" />;
    replaceSuperBtn = replaceSuperBtn || multiLang['page-search-0003'];

    function metaPreHandler(meta, multiLang) {
        const items = meta.items;
        const functionList = getFunctionList(multiLang);
        const select = 'select';
        const targt = [
            'datepicker',
            'datetimepicker',
            'rangepicker',
            'NCTZDatePickerStart',
            'NCTZDatePickerEnd',
            'NCTZDatePickClientTime',
            'NCTZDatePickClientHourTime',
            'NCTZDatePickerRangeDay',
            'datePickerNoTimeZone',
        ];
        const handler = i => {
            if (i.children) {
                i.children.forEach(ii => handler(ii));
            } else {
                const item =
                    items.find(ii => ii.attrcode == i.attrcode) || {};
                const mytar = [select, ...targt];
                let value = i.initialvalue.value;
                if (value && mytar.some(ii => ii == item.itemtype)) {
                    if (
                        i.operationSign === 'between' ||
                        item.isMultiSelectedEnabled ||
                        i.operationSign === 'not between'
                    ) {
                        if (typeof value == 'string') {
                            value = value.split(',');
                        }
                    }
                    if (item.itemtype == 'select') {
                        if (isEmpty(item.options)) {
                            item.options = [i.initialvalue];
                        }
                        let res =
                            item.options.filter(ii => {
                                if (typeof value == 'string') {
                                    return ii.value == value;
                                } else {
                                    return value.find(
                                        iii => ii.value === iii,
                                    );
                                }
                            }) || [];
                        i.initialvalue.display = res
                            .map(ii => ii.display)
                            .join(',');
                    } else if (targt.some(ii => ii == item.itemtype)) {
                        if (Array.isArray(value)) {
                            i.initialvalue.display = value
                                .map(ii =>
                                    timeFunctionHandler(ii)
                                        ? functionList[ii]
                                        : ii,
                                )
                                .join(',');
                        } else {
                            i.initialvalue.display = timeFunctionHandler(value)
                                ? functionList[value]
                                : value;
                        }
                    }
                }
            }
        };
        if (Array.isArray(meta.queryschemes)) {
            meta.queryschemes.forEach(qs => {
                if (Array.isArray(qs.renderobj4web)) {
                    qs.renderobj4web.forEach(i => handler(i));
                }
            });
        }
    }

    /* 点击高级,控制查询面板的显影性 */
    function searchAdvBtnClick (search, type, choosePlanName) {
        that.activeElement = document.activeElement;
        if (isFunction(replaceAdvBtnEve)) {
            replaceAdvBtnEve();
        } else {
            /* 请求候选条件 */ //暂时不访问请求候选条件的接口
            document.body.style.overflow = 'hidden';
            search.showAdvModal = true;
            let currentClickPlan =
                choosePlanName &&
                search.searchPlanCache.find(
                    item => item.name === choosePlanName,
                );
                //如果点击的查询方案和当前方案不一致
            if (
                currentClickPlan &&
                    currentClickPlan.pk_ncc_queryscheme !==
                        search.currentPlan.pk_ncc_queryscheme
            ) {
                search.currentClickPlan = currentClickPlan;
            }
            search.isDefaultPlan =
                    search.currentPlan.pk_ncc_queryscheme == '001';
            search.currentPlan.renderobj4web_snap ||
                    initSimpleSnap(context, search, search.currentPlan);
                search.currentClickPlan?.renderobj4web_snap ||
                    initSimpleSnap(context, search, search.currentClickPlan);
                let currentPlan = search.currentClickPlan || search.currentPlan;
                if (
                    currentPlan &&
                    !isEmpty(currentPlan.renderobj4web_snap) &&
                    currentPlan.renderobj4web_snap[0].attrcode == 'root'
                ) {
                    search.status = 'super';
                } else {
                    search.status = 'normal';
                }
                //特殊情况
                // if (onlyShowAdvArea) {
                //     search.status = 'normal';
                // }
                if (onlyShowSuperCondition) {
                    search.status = 'super';
                }
                if (typeof type !== 'string') {
                    type = '1';
                }
                search.leftTab = type || '1';
                search.isRenderAdv = true;
                if (choosePlanName) {
                    PubSub.publish('searchChoosePlan', choosePlanName);
                }
                setStateEve(() => {
                    if (isFunction(clickAdvBtnEve)) {
                        clickAdvBtnEve();
                    } else if (isFunction(statusChangeEvent)) {
                        statusChangeEvent(search.status);
                    }
                });
        }
    }

    /* 关闭模态框 */
    const closeModal = flag => {
        searchInfo.showAdvModal = false;
        !flag && modalCloseEve && modalCloseEve();
        setStateEve();
    };

    /*只渲染弹窗时，请求模板外的查询方案*/ 
    // function queryExcludeTemplateSchema(appcode, pagecode, metaId,searchInfo){
    //     ajax({
    //         url: '/nccloud/platform/templet/getqueryschemelist.do',
    //         async: true,//请求是否异步,等待接口返回数据后再执行
    //         data: { appcode, pagecode, metaid:metaId},
    //         success: res => {
    //             if (res.success) {
    //                 //这里不应该永远都是默认方案+快速查询+接口返回吗
    //                 //过滤出默认方案+快速查询后，加接口返回
    //                 let attachSchemes = res.data || [];
    //                 const queryschemes = [...searchInfo.searchPlanCache.filter(item => item.isquickqs || item.pk_ncc_queryscheme === '001' || (item.pk_ncc_queryscheme === meta.defaultPrepared && !item.isquickqs )),...attachSchemes];
    //                 searchInfo.searchPlanCache = [...queryschemes];
    //                 meta.queryschemes = queryschemes.filter(
    //                     (item) => item.pk_ncc_queryscheme != '001'
    //                 );
    //             }
    //         },
    //     });
    // }

    // 更新界面方案(外部请求处理需要) add by wanglongx
    const upDateSearchPlan = newSearch => {
        searchInfo.snapshotMap['simple'] = [...searchInfo.fixedConditionGroup, ...newSearch.renderobj4web];
        searchInfo.currentPlan = newSearch;
        setStateEve();
    };

    return (
        <div
            // 给快捷键用
            id={`hot-key-${moduleId}`}
            ref={dom => {
                this.searchDom = ReactDOM.findDOMNode(dom);
            }}
            className={`search-area-contant${
                showAdvBtn ? '' : ' search-area-contant-margin'
            } search-${searchInfo.uniqueKey}`}
            fieldid={
                !onlyShowSuperBtn &&
                getSysFieldid(
                    fieldid ? `${fieldid}_search-area` : 'search-area',
                )
            }
        >
            {!onlyShowAdvArea ? (
                !onlyShowModal ? (
                    <div className="NC_CreateSearch">
                        {(searchInfo.status === 'simple' ||
                            searchInfo.showAdvModal ||
                            onlyShowSuperBtn) && (
                            <SearchSimCom
                                moduleId={moduleId}
                                _this={this}
                                oid={meta.oid}
                                clickSearchBtn={clickSearchBtn}
                                searchBtnName={searchBtnName}
                                onAfterEvent={onAfterEvent}
                                onBeforeEvent={onBeforeEvent}
                                showSearchBtn={showSearchBtn}
                                showAdvBtn={showAdvBtn}
                                hideMoreBtn={hideMoreBtn}
                                showClearBtn={showClearBtn}
                                replaceAdvBtnEve={replaceAdvBtnEve}
                                saveSearchPlan={saveSearchPlan}
                                clickPlanEve={clickPlanEve}
                                clickAdvBtnEve={clickAdvBtnEve}
                                hideBtnArea={hideBtnArea}
                                advSearchClearEve={advSearchClearEve}
                                advSearchClearCurrentEve={advSearchClearCurrentEve}
                                onlyShowSuperBtn={onlyShowSuperBtn}
                                showFoldBtn={showFoldBtn}
                                replaceSuperBtn={replaceSuperBtn}
                                onOperateTypeChange={onOperateTypeChange}
                                onlyShowAdvArea={onlyShowAdvArea}
                                onlyShowModal={onlyShowModal}
                                statusChangeEvent={statusChangeEvent}
                                context={context}
                                renderItem={renderItem}
                                setInitValueEvent={setInitValueEvent}
                                onlyShowPlan={onlyShowPlan}
                                currentSearch={currentSearch}
                                fieldid={fieldid}
                                clickShowLableEve={clickShowLableEve}
                                opneBtnClick={opneBtnClick}
                                isTemplateOrder={isTemplateOrder}
                                onlyShowSuperCondition={onlyShowSuperCondition}
                                modalCloseEve={modalCloseEve}
                                searchInfo={searchInfo}
                                meta={meta}
                                multiLang={multiLang}
                                hideSearchPlan={hideSearchPlan}
                                LangData={LangData}
                                hiddenFunList={hiddenFunList}
                                setStateEve={setStateEve}
                                searchPlanCacheChange={i =>
                                    searchPlanCacheChange(i)
                                } // 查询方案修改回调
                                upDateSearchPlan={e => upDateSearchPlan(e)} //更新当前界面的查询方案
                                modal={this.props.modal}
                                showAdvSearchPlanBtn={showAdvSearchPlanBtn} // 是否显示保存另存方案按钮
                                showAddSearchPlan={showAddSearchPlan}
                                showLable={showLable}
                                isWidgetMode={isWidgetMode}
                                runMode={runMode}
                                showSearchLable={showSearchLable}
                                searchAdvBtnClick={searchAdvBtnClick}
                                underlineBorder={underlineBorder}
                                metaId={meta.metaid}
                                customAppCode={customAppCode}
                                customPageCode={customPageCode}
                                hiddenShareBtn={hiddenShareBtn}
                                activeElement = { this.activeElement}
                                maxColumn={maxColumn}
                                customAdvBtns={customAdvBtns}
                                getQueryScheme={this.getQueryScheme}
                            />
                        )}
                        {showAdvBtn &&
                        (isSynInitAdvSearch ||
                            this.state.searchInfo.isRenderAdv) ? (
                                <SearchAdvModal
                                    ref = {ref=>{
                                        if(ref){
                                            this.closeModalApi = ref.cancelClick;
                                        }
                                    }}
                                    moduleId={moduleId}
                                    setStateEve={setStateEve}
                                    searchBtnName={searchBtnName}
                                    searchModalTitle={searchModalTitle}
                                    searchConditionName={searchConditionName}
                                    onlyShowSuperCondition={onlyShowSuperCondition}
                                    hideSearchType={hideSearchType}
                                    className={`${
                                        searchInfo.showAdvModal
                                            ? 'showAdvModal'
                                            : 'hideAdvModal'
                                    }`}
                                    closeModal={closeModal}
                                    isShow={searchInfo.showAdvModal}
                                    searchBtnClick={clickSearchBtn}
                                    onAfterEvent={onAfterEvent} // 编辑后事件
                                    onBeforeEvent={onBeforeEvent}
                                    showAdvSearchPlanBtn={showAdvSearchPlanBtn} // 是否显示保存方案按钮
                                    replaceAdvBody={replaceAdvBody} // 替换整个body
                                    addAdvTabs={addAdvTabs} // 添加自定义页签
                                    addAdvBody={addAdvBody} // 在body区域添加自定义条件
                                    addAdvBodyBottom={addAdvBodyBottom}
                                    searchPlanCache={searchInfo.searchPlanCache} // 查询方案变量缓存记录
                                    searchPlanCacheChange={i =>
                                        searchPlanCacheChange(i)
                                    } // 查询方案修改回调
                                    upDateSearchPlan={e => upDateSearchPlan(e)} //更新当前界面的查询方案
                                    oid={meta.oid}
                                    hideSearchCondition={hideSearchCondition} // 隐藏候选条件
                                    hideSearchPlan={hideSearchPlan}
                                    saveSearchPlan={saveSearchPlan} // 业务组自定义查询条件当前数据
                                    replaceRightBody={replaceRightBody} // 替换右侧body区域
                                    clickPlanEve={clickPlanEve} // 查询方案点击事件回调函数，用于业务组设置自定义查询区数据
                                    advSearchClearEve={advSearchClearEve} // 高级面板中的清空按钮点击事件回调
                                    advSearchClearCurrentEve={advSearchClearCurrentEve}
                                    // afterEditSearchPlan={afterEditSearchPlan} // 如果修改了默认方案，则需要更新查询展示
                                    onOperateTypeChange={onOperateTypeChange}
                                    searchInfo={searchInfo}
                                    _this={this}
                                    statusChangeEvent={statusChangeEvent}
                                    onlyShowSuperBtn={onlyShowSuperBtn}
                                    renderItem={renderItem}
                                    setInitValueEvent={setInitValueEvent}
                                    meta={meta}
                                    multiLang={this.state.json}
                                    LangData={LangData}
                                    leftTab={this.state.searchInfo.leftTab} // 控制页签
                                    fieldid={fieldid}
                                    removeQuerConditionEve={removeQuerConditionEve}
                                    onDropConditionEve={onDropConditionEve}
                                    isTemplateOrder={isTemplateOrder}
                                    hiddenFunList={hiddenFunList}
                                    activeElement = { this.activeElement}
                                    maxColumn={maxColumn}
                                    customAdvBtns={customAdvBtns}
                                    getQueryScheme={this.getQueryScheme}
                                    {...this.props}
                                />
                            ) : null}
                    </div>
                ) : showAdvBtn &&
                  (isSynInitAdvSearch || this.state.searchInfo.isRenderAdv) ? (
                        <SearchAdvModal
                            ref = {ref=>{
                                if(ref){
                                    this.closeModalApi = ref.cancelClick;
                                }
                            }}
                            moduleId={moduleId}
                            setStateEve={setStateEve}
                            searchBtnName={searchBtnName}
                            searchModalTitle={searchModalTitle}
                            searchConditionName={searchConditionName}
                            hideSearchType={hideSearchType}
                            onlyShowSuperCondition={onlyShowSuperCondition}
                            className={`${
                                searchInfo.showAdvModal
                                    ? 'showAdvModal'
                                    : 'hideAdvModal'
                            }`}
                            closeModal={closeModal}
                            isShow={searchInfo.showAdvModal}
                            searchBtnClick={clickSearchBtn}
                            onAfterEvent={onAfterEvent} // 编辑后事件
                            onBeforeEvent={onBeforeEvent}
                            showAdvSearchPlanBtn={showAdvSearchPlanBtn} // 是否显示保存方案按钮
                            replaceAdvBody={replaceAdvBody} // 替换整个body
                            addAdvTabs={addAdvTabs} // 添加自定义页签
                            addAdvBody={addAdvBody} // 在body区域添加自定义条件
                            addAdvBodyBottom={addAdvBodyBottom}
                            searchPlanCache={searchInfo.searchPlanCache} // 查询方案变量缓存记录
                            searchPlanCacheChange={i => searchPlanCacheChange(i)} // 查询方案修改回调
                            upDateSearchPlan={e => upDateSearchPlan(e)} //更新当前界面的查询方案
                            oid={meta.oid}
                            hideSearchCondition={hideSearchCondition} // 隐藏候选条件
                            hideSearchPlan={hideSearchPlan}
                            saveSearchPlan={saveSearchPlan} // 业务组自定义查询条件当前数据
                            replaceRightBody={replaceRightBody} // 替换右侧body区域
                            clickPlanEve={clickPlanEve} // 查询方案点击事件回调函数，用于业务组设置自定义查询区数据
                            advSearchClearEve={advSearchClearEve} // 高级面板中的清空按钮点击事件回调
                            advSearchClearCurrentEve={advSearchClearCurrentEve}
                            // afterEditSearchPlan={afterEditSearchPlan} // 如果修改了默认方案，则需要更新查询展示
                            onOperateTypeChange={onOperateTypeChange}
                            searchInfo={searchInfo}
                            _this={this}
                            statusChangeEvent={statusChangeEvent}
                            onlyShowSuperBtn={onlyShowSuperBtn}
                            renderItem={renderItem}
                            setInitValueEvent={setInitValueEvent}
                            meta={meta}
                            multiLang={this.state.json}
                            LangData={LangData}
                            leftTab={this.state.searchInfo.leftTab} // 控制页签
                            removeQuerConditionEve={removeQuerConditionEve}
                            onDropConditionEve={onDropConditionEve}
                            isTemplateOrder={isTemplateOrder}
                            hiddenFunList={hiddenFunList}
                            activeElement = { this.activeElement}
                            maxColumn={maxColumn}
                            customAdvBtns={customAdvBtns}
                            getQueryScheme={this.getQueryScheme}
                            {...this.props}
                        />
                    ) : null
            ) : (
                <div
                    className="NC_searchAdvModal"
                    fieldid={getSysFieldid('search_modal-area')}
                    style={{ width: '100%' }}
                >
                    <SearchAdvCom
                        className={`${
                            searchInfo.showAdvModal
                                ? 'showAdvModal'
                                : 'hideAdvModal'
                        }`}
                        getChildrenRefToB={e => getChildrenRefToB(e)}
                        moduleId={moduleId}
                        setStateEve={setStateEve}
                        searchBtnName={searchBtnName}
                        closeModal={closeModal}
                        searchBtnClick={clickSearchBtn}
                        onAfterEvent={onAfterEvent} // 编辑后事件
                        onBeforeEvent={onBeforeEvent}
                        showAdvSearchPlanBtn={showAdvSearchPlanBtn} // 是否显示保存方案按钮
                        replaceAdvBody={replaceAdvBody} // 替换整个body
                        addAdvTabs={addAdvTabs} // 添加自定义页签
                        searchConditionName={searchConditionName}
                        hideSearchType={hideSearchType}
                        onlyShowSuperCondition={onlyShowSuperCondition}
                        addAdvBody={addAdvBody} // 在body区域添加自定义条件
                        addAdvBodyBottom={addAdvBodyBottom}
                        searchPlanCache={searchInfo.searchPlanCache} // 查询方案变量缓存记录
                        searchPlanCacheChange={i => searchPlanCacheChange(i)} // 查询方案修改回调
                        upDateSearchPlan={e => upDateSearchPlan(e)} //更新当前界面的查询方案
                        oid={meta.oid}
                        hideSearchCondition={hideSearchCondition} // 隐藏候选条件
                        hideSearchPlan={hideSearchPlan}
                        saveSearchPlan={saveSearchPlan} // 业务组自定义查询条件当前数据
                        replaceRightBody={replaceRightBody} // 替换右侧body区域
                        clickPlanEve={clickPlanEve} // 查询方案点击事件回调函数，用于业务组设置自定义查询区数据
                        advSearchClearEve={advSearchClearEve} // 高级面板中的清空按钮点击事件回调
                        advSearchClearCurrentEve={advSearchClearCurrentEve}
                        // afterEditSearchPlan={afterEditSearchPlan} // 如果修改了默认方案，则需要更新查询展示
                        onOperateTypeChange={onOperateTypeChange}
                        searchInfo={searchInfo}
                        _this={this}
                        statusChangeEvent={statusChangeEvent}
                        onlyShowSuperBtn={onlyShowSuperBtn}
                        renderItem={renderItem}
                        meta={meta}
                        setInitValueEvent={setInitValueEvent}
                        multiLang={this.state.json}
                        LangData={LangData}
                        isTemplateOrder={isTemplateOrder}
                        removeQuerConditionEve={removeQuerConditionEve}
                        onDropConditionEve={onDropConditionEve}
                        hiddenFunList={hiddenFunList}
                        activeElement = { this.activeElement}
                        maxColumn={maxColumn}
                        customAdvBtns={customAdvBtns}
                        getQueryScheme={this.getQueryScheme}
                        {...this.props}
                    />
                </div>
            )}
        </div>
    );
}
